export default __webpack_public_path__ + "static/media/SubmissionReady.15e52b26.svg";